<ng-container [formGroup]="form">
  <app-base-field-html [form]="form" [fieldData]="fieldData" [editMode]="editMode" [readonly]="readonly"
                       [hideField]="hideField" [scrollContainer]="scrollContainer" [inputId]="inputId"
                       (emitPush)="push()">

    <div [ngClass]="{'uk-disabled': readonly}">
      @if (fieldData.typeInfo.multiplicity) {
        <div [formArrayName]="fieldData.name">
          <div appSortable (positionChanged)="onPositionChanged($event)" id="sortable-container">
            @for (input of formArrayControls; track input; let i = $index) {
              <div id="{{i}}" [attr.data-index]="i" class="uk-margin-bottom uk-flex uk-flex-middle">
                <input [id]="inputId+'.['+i+']'" [formControlName]="i" class="uk-input uk-width-9-10 uk-animation-scale-up"
                       [placeholder]="fieldData.form.placeholder ? fieldData.form.placeholder : ''"
                       [ngClass]="{'uk-form-danger': checkFormArrayValidity(i)}"
                       (focusin)="focus(i)" (focusout)="focusOut(false, i)"
                       (input)="updateBitSet(fieldData); unsavedChangesPrompt()">
                @if (formArrayControls.length > 1 && !readonly) {
                  <div class="">
                    <span class="uk-sortable-handle uk-text-center uk-margin-small-left" data-uk-icon="icon: move"></span>
                  </div>
                }
                @if (formArrayControls.length > 1 && !readonly) {
                  <a (click)="remove(i); updateBitSet(fieldData); unsavedChangesPrompt()"
                     class="remove-element uk-margin-left">
                    <span class="material-icons">clear</span>
                  </a>
                }
              </div>
            }
          </div>
        </div>
      } @else {
        <div>
          <input class="uk-input uk-width-9-10 uk-animation-scale-up" [ngClass]="{'uk-form-danger': checkFormValidity()}"
                 [formControlName]="fieldData.name" [id]="inputId" [placeholder]="fieldData.form.placeholder ?? ''"
                 (input)="updateBitSet(fieldData); unsavedChangesPrompt()"
                 (focusin)="focus()" (focusout)="focusOut(false)">
        </div>
      }
    </div>

  </app-base-field-html>
</ng-container>
